module.exports = __webpack_public_path__ + "static/media/swap.0e58399c.png";